export const CREATE_ROUTE = {
  name: 'Create',
  path: 'new',
};
